"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const StyledButton_1 = require("./styled/StyledButton");
const useAsyncEventHandler = (callback) => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const isMounted = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);
    const handleClick = async (event) => {
        if (loading || !callback)
            return;
        setLoading(true);
        try {
            await callback(event);
        }
        finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    };
    return [loading, handleClick];
};
const Button = (0, react_1.forwardRef)((props, ref) => {
    const { size = 'medium', variant = 'primary', isAsync, onClick, children, loading } = props, otherProps = __rest(props, ["size", "variant", "isAsync", "onClick", "children", "loading"]);
    const [isLoading, handleClick] = useAsyncEventHandler(onClick);
    const controlledProps = { size, variant, onClick: handleClick, ref, isLoading };
    if (!isAsync) {
        controlledProps.onClick = onClick;
        controlledProps.isLoading = !!loading;
    }
    return ((0, jsx_runtime_1.jsxs)(StyledButton_1.StyledButton, Object.assign({}, controlledProps, otherProps, { children: [(0, jsx_runtime_1.jsx)(StyledButton_1.StyledContent, { isLoading: controlledProps.isLoading, children: children }), controlledProps.isLoading && (0, jsx_runtime_1.jsx)(StyledButton_1.Loader, { butterfly: false, width: "100%", height: "100%" })] })));
});
exports.Button = Button;
Button.displayName = 'Button';
exports.default = Button;
